/**
 * Take one or more media streams and return a MediaRecorder that records all of them
 *
 * @param streams - The media streams to record
 * @returns A MediaRecorder that records all of the input streams
 * */
export function combineAudioStreamsToMediaRecorder(
  streams: MediaStream[],
): MediaRecorder {
  const stream = streams.shift()
  if (!stream) {
    throw new Error('No stream to record')
  }

  // Create audio context
  const audioContext = new AudioContext()

  // Create a destination node where we'll connect all our streams
  const destinationNode = audioContext.createMediaStreamDestination()
  audioContext.createMediaStreamSource(stream).connect(destinationNode)

  // For each stream, create a source node and connect it to the destination
  for (const stream of streams) {
    audioContext.createMediaStreamSource(stream).connect(destinationNode)
  }

  // Create a MediaRecorder using the mixed audio stream
  const mediaRecorder = new MediaRecorder(destinationNode.stream)

  return mediaRecorder
}
